import {
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  TextFielDecimalNumbers,
  Checkbox,
  FormControlLabel,
} from "../../../../components";
import { value } from "../../../../helpers";

export default function ModeloTributacaoIbs({
  grupoModeloTributacao,
  setGrupoModeloTributacao,
  handleInputChange,
  situacaoIbsList,
  classificacaoIbsList,
  setClassificacaoIbsList,
  buscaClassificacoesIbs,
  codigosCredPres,
  onChangeAutocomplete,
  handleCheckBox,
}) {

  const handleChangeSituacaoIbs = (e, value) => {
    onChangeAutocomplete("classificacaoIbsId", null);
    if (value) {
      buscaClassificacoesIbs(value.codigo);
    } else {
      setClassificacaoIbsList([]);
      setGrupoModeloTributacao((prevState) => ({
        ...prevState,
        classificacaoIbsId: null,
        aliquotaIbsUf: null,
        aliquotaIbsMun: null,
        aliquotaCbs: null,
        aliquotaIbsUfRed: null,
        aliquotaIbsMunRed: null,
        aliquotaCbsRed: null,
        credPresIbsId: null,
        aliquotaCredPresIbs: null,
        aliquotaCredPresCbs: null,
      }));
    }
    onChangeAutocomplete("situacaoIbsId", value);
  }

  const handleChangeClassificacaoIbs = (e, value) => {
    onChangeAutocomplete("classificacaoIbsId", value);
    setGrupoModeloTributacao((prevState) => ({
      ...prevState,
      aliquotaIbsUf: value ? prevState.aliquotaIbsUf : null,
      aliquotaIbsMun: value ? prevState.aliquotaIbsMun  : null,
      aliquotaCbs: value ? prevState.aliquotaCbs  : null,
      aliquotaIbsUfRed: value?.reducaoIbs,
      aliquotaIbsMunRed: value?.reducaoIbs,
      aliquotaCbsRed: value?.reducaoCbs,
      credPresIbsId: value ? prevState.credPresIbsId : null,
      aliquotaCredPresIbs: value ? prevState.aliquotaCredPresIbs : null,
      aliquotaCredPresCbs: value ? prevState.aliquotaCredPresCbs : null,
    }));
  }

  const handleChangeCodigoCredPres = (e, value) => {
    onChangeAutocomplete("credPresIbsId", value);
    setGrupoModeloTributacao((prevState) => ({
      ...prevState,
      aliquotaCredPresIbs: value ? prevState.aliquotaCredPresIbs : null,
      aliquotaCredPresCbs: value ? prevState.aliquotaCredPresCbs : null,
    }));
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="situacaoIbsId"
              name="situacaoIbsId"
              options={situacaoIbsList}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigo} - ${option?.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Situação Tributária IBS/CBS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={handleChangeSituacaoIbs}
              value={value.autoComplete(
                situacaoIbsList,
                grupoModeloTributacao?.situacaoIbsId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="classificacaoIbsId"
              name="classificacaoIbsId"
              options={classificacaoIbsList}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigoClassificacao} - ${option?.nomeClassificacao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Classificação IBS/CBS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={handleChangeClassificacaoIbs}
              value={value.autoComplete(
                classificacaoIbsList,
                grupoModeloTributacao?.classificacaoIbsId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsUf"
            name="aliquotaIbsUf"
            label="Alíquota IBS UF"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsUf ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsMun"
            name="aliquotaIbsMun"
            label="Alíquota IBS Municipal"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsMun ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaCbs"
            name="aliquotaCbs"
            label="Alíquota CBS"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaCbs ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsUfRed"
            name="aliquotaIbsUfRed"
            label="Alíquota IBS UF Red."
            margin="normal"
            variant="filled"
            disabled
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsUfRed ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsMunRed"
            name="aliquotaIbsMunRed"
            label="Alíquota IBS Municipal Red."
            margin="normal"
            variant="filled"
            disabled
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsMunRed ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaCbsRed"
            name="aliquotaCbsRed"
            label="Alíquota CBS Red."
            margin="normal"
            variant="filled"
            disabled
            fullWidth
            value={grupoModeloTributacao?.aliquotaCbsRed ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        {grupoModeloTributacao?.classificacaoIbsId &&
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="credPresIbsId"
                name="credPresIbsId"
                options={codigosCredPres}
                autoHighlight
                getOptionLabel={(option) =>
                  option ? `${option?.codigo} - ${option?.descricao}` : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Modalidade de Crédito Presumido"
                    variant="outlined"
                    margin="normal"
                  />
                )}
                onChange={handleChangeCodigoCredPres}
                value={value.autoComplete(
                  codigosCredPres,
                  grupoModeloTributacao?.credPresIbsId
                )}
              />
            </FormControl>
          </Grid>
        }
        {grupoModeloTributacao?.credPresIbsId &&
          <>
            <Grid item xs={6}>
              <TextFielDecimalNumbers
                id="aliquotaCredPresIbs"
                name="aliquotaCredPresIbs"
                label="Percentual do Crédito Presumido (IBS)"
                margin="normal"
                variant="outlined"
                fullWidth
                value={grupoModeloTributacao?.aliquotaCredPresIbs ?? ""}
                onBlur={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextFielDecimalNumbers
                id="aliquotaCredPresCbs"
                name="aliquotaCredPresCbs"
                label="Percentual do Crédito Presumido (CBS)"
                margin="normal"
                variant="outlined"
                fullWidth
                value={grupoModeloTributacao?.aliquotaCredPresCbs ?? ""}
                onBlur={handleInputChange}
              />
            </Grid>
          </>
        }
      </Grid>
      <Grid container spacing={2} className="mt-1">
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.descontoIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.descontoIbsBase}
                name="descontoIbsBase"
              />
            }
            label="Desconto na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.despesaIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.despesaIbsBase}
                name="despesaIbsBase"
              />
            }
            label="Despesa na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.ipiIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.ipiIbsBase}
                name="ipiIbsBase"
              />
            }
            label="IPI na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.freteIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.freteIbsBase}
                name="freteIbsBase"
              />
            }
            label="Frete na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.seguroIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.seguroIbsBase}
                name="seguroIbsBase"
              />
            }
            label="Seguro na base"
          />
        </Grid>
      </Grid>
    </>
  );
}
